import { createTheme } from "@mui/material";
import default_logo from "./assets/images/app_logo.svg";
export const default_theme = createTheme({
  logo: default_logo,
  favicon: default_logo,
  site_title: "CO2OPT Reifenmanagement",

  palette: {
    common: {
      black: "#000",
      white: "#fff",
      yellow: "#F7E993",
      main: "#F7E993",
    },
    primary: {
      //Co2opt theme
      light: "#67A426OD",
      main: "#69A628",
      alt: "#d2ddc7",
      alt1: "#376604",
      link: "#3577DC",
      contrastText: "#fff",
    },
    secondary: {
      main: "#D10011",
      alt: "#860510",

      // dark: will be calculated from palette.secondary.main,
      contrastText: "#fff",
    },

    boxShadow: "0px 9.59195px 35.9698px rgba(0, 0, 0, 0.04)",
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 960,
      lg: 1280,
      xl: 1920,
    },
  },
  typography: {
    fontFamily: ["Open Sans"],
  },
  zIndex: {
    speedDial: 1050,
    appBar: 1100,
    drawer: 1200,
    modal: 1300,
    snackbar: 1400,
    tooltip: 1500,
  },
  shape: {
    borderRadius: 8,
  },
});
